import * as React from 'react';
import { ImgHTMLAttributes } from 'react';
import {
  alignSelf,
  color,
  display,
  DisplayProps,
  height,
  justifySelf,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  space,
  SpaceProps,
  width,
} from 'styled-system';
import { SelfPositioningProps, SizingProps } from '~frontend-common/lib/styled-components';
import { styled } from '~ui-kit/styled-components';

export interface ImgProps
  extends SizingProps,
    SpaceProps,
    DisplayProps,
    SelfPositioningProps,
    ImgHTMLAttributes<HTMLImageElement> {
  height?: any;
  width?: any;
}

export const Img: React.SFC<ImgProps> = styled.img`
  ${space};
  ${color};
  ${alignSelf};
  ${justifySelf};
  ${height};
  ${minHeight};
  ${maxHeight};
  ${height};
  ${width};
  ${minWidth};
  ${maxWidth};
  ${display};
` as any;
